<ng-container *ngIf="inputs | async as inputs_">
  <th><!-- Za checkboxove --></th>
  <th>
    <!-- Za arhivsku oznaku -->
  </th>
  <ng-container appBrziObrazacStateServiceProvider>
    <ng-container *ngFor="let input of inputs_">
      <th *ngIf="input.attributeMetadata.name !== 'en~jedinica_gradiva~arhivska_oznaka'">
        <div
          *ngIf="input.attributeMetadata.control_type !== 0 && input.attributeMetadata.category !== 'Sustav' && input.attributeMetadata.read_only !== true">
          <div class="property-input" [ngClass]="'attr-' + input.attributeMetadata.name">
            <ntap-dynamic [compId]="input.componentId" [inputParam]="getInputParam(input)">
            </ntap-dynamic>
          </div>
        </div>
      </th>
    </ng-container>
  </ng-container>
  <th style="width: 0">
    <!-- Za inline spremi akciju na retku -->
  </th>
  <th style="width: 0">
    <div class="inline entry-template-toolbar">
      <div class="input-amount flex flex-nowrap">
        <span class="m-auto">Obrazac unosa:</span>&nbsp;
        <app-entry-template-dropdown (selectObrazacUpisa)="selectEntryTemplate($event)"></app-entry-template-dropdown>
        <ng-container *ngIf="multivalueActionState$ | async as multivalueActionState">
          <p-inputNumber [min]="0" placeholder="Komada" [(ngModel)]="amount" class="mx-3"></p-inputNumber>
          <p-button icon="pi pi-plus" pTooltip="Dodaj" ntapDebounceClick (onClick)="addAmountUsingTemplate()"
            class="mr-1"></p-button>
          <p-button icon="pi pi-save" pTooltip="Primjeni na označeno" ntapDebounceClick (onClick)="applyEntryTemplate()"
            class="mr-1" [disabled]="multivalueActionState.disabled"></p-button>
          <p-button icon="pi pi-trash" pTooltip="Obriši označeno" ntapDebounceClick (onClick)="deleteSelectedJedinice()"
            [disabled]="multivalueActionState.disabled"></p-button>
        </ng-container>
        <i class="pi pi-ellipsis-v p-toolbar-separator" style="margin-top: 0.6rem;"></i>
        <app-fast-data-entry-edit-template-bar></app-fast-data-entry-edit-template-bar>
      </div>
    </div>
  </th>
</ng-container>